export async function loadLifeUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("life", async (container) => {
        const { LifeUpdater } = await import("./LifeUpdater.js");
        return new LifeUpdater(container);
    }, refresh);
}
